import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MyUtils } from 'src/app/services/my-utils.service';

export interface MessageError {
  title: '', message: '', subMessage: '' 
}

@Component({
  selector: 'app-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss']
})
export class InfoDialogComponent implements OnInit {

  constructor(private dialog: MatDialog, 
    @Inject(MAT_DIALOG_DATA) public data: MessageError, 
    public utils: MyUtils) { }

  ngOnInit(): void {
  }

}
